/* Maat-pill-rij: één tik = maat + alleen-op-voorraad, via het bestaande
   facet-mechanisme (FacetFiltersForm.renderPage → fetch + history API).
   Zelfde patroon als FacetRemove in component-facets.js: custom element
   om <a>-links heen; her-initialiseert automatisch (custom element upgrade)
   nadat het facet-mechanisme #CollectionProductGrid vervangen heeft.
   Zonder JS navigeert de href server-side naar dezelfde filterstaat. */
class SizePillNav extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.#onClick.bind(this));
  }

  #onClick(event) {
    const pill = event.target.closest('[data-js-size-pill]');
    if (!pill) return;
    if (typeof FacetFiltersForm === 'undefined') return; // href-fallback

    event.preventDefault();

    const params = new URLSearchParams(window.location.search);
    const wasActive = pill.getAttribute('aria-pressed') === 'true';

    // radio-gedrag: altijd hooguit één maat actief; filterwijziging reset paginering
    params.delete(this.dataset.sizeParam);
    params.delete('page');

    if (wasActive) {
      params.delete(this.dataset.availabilityParam);
    } else {
      params.set(this.dataset.sizeParam, pill.dataset.value);
      params.set(this.dataset.availabilityParam, '1');
    }

    FacetFiltersForm.renderPage(params.toString());
  }
}

if (!customElements.get('size-pill-nav')) {
  customElements.define('size-pill-nav', SizePillNav);
}
